// extracted by mini-css-extract-plugin
module.exports = {"BtnGroup":"ElectricityCalculator_BtnGroup___1N6k"};